import React, { Component } from 'react';
import BookMarkIcon from 'Containers/Icon/BookMarkIcon/BookMarkIcon.jsx';
export class AgGridBookMark extends Component {
    constructor(props) {
        super(props);
        this.invokeParentMethod = this.invokeParentMethod.bind(this);
    }

    render() {
        return (
            <span style={{cursor:'pointer'}}>
                <BookMarkIcon id={this.props.node.rowIndex} 
                 isBookMarked={this.props.context.componentParent.props.bookMarkedRows !== undefined && 
                              this.props.data !== undefined && 
                              this.props.context.componentParent.props.bookMarkedRows.includes(this.props.data.caseStageId)} 
                toggleBookMark={this.invokeParentMethod} height='20px' width='20px' />
            </span>
        );
    }

    invokeParentMethod(keySeqKey) {
        this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && this.props.context.componentParent.props.onBookMarked && this.props.context.componentParent.props.onBookMarked(this.props.node.rowIndex, this.props.data.caseStageId);
    };
}
export default AgGridBookMark;